import toast from 'react-hot-toast';
import { profileService } from '../services';
import { BankCredential, BankData } from '../types';

const handleError = (e: any) => {
  console.error(e.response.data);
  toast.error(e.response?.data || e.message);
  throw new Error(e.response?.data || e.message);
};

export const createBankAccount = async (data: BankData) => {
  try {
    const res = await profileService.post('/companies/accounts', data);
    return res.data;
  } catch (e) {
    handleError(e);
  }
};

export const getBankAccounts = async () => {
  try {
    const res = await profileService.get('/company/bank-accounts');
    return res.data;
  } catch (e) {
    handleError(e);
  }
};

export const editBankAccount = async (accountIndex: number, data: BankData) => {
  try {
    const res = await profileService.patch(`/company/bank-account/${accountIndex}`, data);
    return res.data;
  } catch (e) {
  }
};

export const deleteBankAccount = async (accountIndex: number) => {
  try {
    const res = await profileService.delete(`/company/bank-account/${accountIndex}`);
    return res.data;
  } catch (e) {
    handleError(e);
  }
};

